import React from 'react'
import { CuratedFeedTopic } from '@/services/curatedSourceService'

const TOPICS = Object.values(CuratedFeedTopic)

interface TopicSelectorProps {
  value: CuratedFeedTopic[]
  onChange: (topics: CuratedFeedTopic[]) => void
  disabled?: boolean
}

const TopicSelector: React.FC<TopicSelectorProps> = ({ value, onChange, disabled }) => {
  const toggleTopic = (topic: CuratedFeedTopic) => {
    const next = value.includes(topic)
      ? value.filter((t) => t !== topic)
      : [...value, topic]
    onChange(next)
  }

  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filter by topic">
      {TOPICS.map((topic) => (
        <button
          key={topic}
          type="button"
          disabled={disabled}
          aria-pressed={value.includes(topic)}
          onClick={() => toggleTopic(topic)}
          className={`px-3 py-1 text-xs rounded-full border transition-colors disabled:opacity-50 ${
            value.includes(topic)
              ? 'bg-primary-600 text-white border-primary-600'
              : 'bg-white text-gray-700 border-gray-300'
          }`}
        >
          {topic}
        </button>
      ))}
      {value.length === 0 && (
        <span className="text-xs text-gray-500">Showing all topics</span>
      )}
    </div>
  )
}

export default TopicSelector
